module.exports = __webpack_public_path__ + "c2848aacde2d388cba47a89a95be606b.svg";